import {
    AudioRawOptions,
    OfficeRawOptions,
    MediaType,
    PictureRawOptions,
    VideoRawOptions,
} from 'models'

function getHeightAndWidth(
    file: File,
): Promise<{ height: number; width: number }> {
    return new Promise((resolve) => {
        const src = URL.createObjectURL(file)
        const img = new Image()
        img.onload = () => {
            resolve({
                height: img.height,
                width: img.width,
            })
            URL.revokeObjectURL(src)
        }
        img.src = src
    })
}

function isImage(file: File): boolean {
    return file.type.startsWith('image/')
}

function isVideo(file: File): boolean {
    return file.type.startsWith('video/')
}

function isAudio(file: File): boolean {
    return file.type.startsWith('audio/')
}

async function getPictureRawOptions(file: File): Promise<PictureRawOptions> {
    const { height, width } = await getHeightAndWidth(file)

    return {
        type: MediaType.picture,
        height,
        width,
    }
}

export const useMediaRawOptions = () => {
    const getRawOptions = async (file: File) => {
        if (isImage(file)) {
            return await getPictureRawOptions(file)
        } else if (isVideo(file)) {
            return {
                type: MediaType.video,
                height: 0,
                width: 0,
                duration: 0,
            } as VideoRawOptions
        } else if (isAudio(file)) {
            return {
                type: MediaType.audio,
                duration: 0,
            } as AudioRawOptions
        }
        return {
            type: MediaType.office,
        } as OfficeRawOptions
    }

    return { getRawOptions }
}
